import "./styles/style.css";

import { Map, View } from "ol";

//CONTROLERS
import Zoom from "ol/control/Zoom";
import ScaleLine from "ol/control/ScaleLine";
import Rotate from "ol/control/Rotate";
import Attribution from "ol/control/Attribution";
import FullScreen from "ol/control/FullScreen";
import MousePosition from "ol/control/MousePosition.js";
import ZoomToExtent from "ol/control/ZoomToExtent";

import Refresh from "./controls/refreshButton";
import bCapaActiva from "./controls/botonCapaActiva";
import MeasureControl from "./controls/botonMeasure";
import MeasureLine from "./controls/botonMeasureLine";
import Dibujo from "./controls/botonDibujo.js";

import Circulo from "./controls/botonDibujoCirculo.js";
import Texto from "./controls/botonTexto.js";

//layers
import { fuentesExternas } from "./layers/fuentes_externas";
import { marcoGeoestadistico } from "./layers/marcoGeoestadistico";
import { censo2001 } from "./layers/censo2001";
import { censo2010 } from "./layers/censo2010";
import { censo2022 } from "./layers/censo2022";
import { baseLayers } from "./layers/baseLayers";
import { cartografiaBase } from "./layers/cartografiaBase";
//extensiones
import LayerSwitcher from "./map/layerSwitcher.js";
import Popup from "ol-popup";
import { createStringYX } from "./utils/createStringYX";
import { onLayerVisibilityChange } from "./map/cambioCapa";
import { imprimir } from "./map/impresion";
import { subirCapa } from "./map/subirCapa.js";
import Impresion from "./controls/botonImpresion";
import Ayuda from "./controls/botonAyuda";
import Geoservicios from "./controls/botonGeoservicios.js";
import { buscadorLocalidades } from "./services/buscadorLocalidades";
import { cambioOrdenCapasActivas } from "./map/ordenCapasActivas";
import { popUP } from "./map/popUp";

import DibujoLinea from "./controls/botonDibujoLinea.js";
import Goma from "./controls/botonGoma.js";
import SubirCapa from "./controls/botonSubirCapa.js";
import { desactivarControlesActivos } from "./map/controles.js";
import { configurarDragAndDrop } from "./map/dragAndDrop.js";
import { configurarInfoFeature } from "./map/infoFeature.js";
import { configurarPuntosUsuario } from "./map/puntosUsuario.js";

const scaleLine = new ScaleLine({ bar: true, text: true }); // Control de escala

// lo que genera el mapa

const map = new Map({
  //controles
  controls: [
    new Zoom({ zoomInTipLabel: "Acercar", zoomOutTipLabel: "Alejar" }), // Control de zoom
    new Rotate(), // Control de rotación
    new Attribution(), // Control de atribución
    new FullScreen({ tipLabel: "Pantalla completa" }),
    new bCapaActiva(),
    new SubirCapa(),
    //
    new MeasureControl({ onActivate: () => desactivarControlesActivos(map) }),
    new MeasureLine({ onActivate: () => desactivarControlesActivos(map) }),
    new Impresion({ tipLabel: "Imprimir mapa" }),
    new Ayuda(),
    new Geoservicios(),
    //
    new Dibujo({ onActivate: () => desactivarControlesActivos(map) }),
    new Circulo({ onActivate: () => desactivarControlesActivos(map) }),
    new DibujoLinea({ onActivate: () => desactivarControlesActivos(map) }),
    new Texto({ onActivate: () => desactivarControlesActivos(map) }),
    new Goma(),
    new MousePosition({
      coordinateFormat: createStringYX(4),
      projection: "EPSG:4326",
      className: "custom-mouse-position",
      target: document.getElementById("mouse-position"),
    }),
    new Refresh(),
    new ZoomToExtent({
      label: " ",
      tipLabel: "Zoom inicial",
      //tucuman
      // (-7579297.1525,-28988881.2432)
      extent: [-7685524.9259, -3260079.4028, -6865275.1616, -2994070.9759],
      //gsmt
      //extent: [-7278753.9878, -3110243.0708, -7240359.4153,-3092280.6960]
      //x- izq arriba, y- izq abajo, x-derecha abajo, y- derecha arriba
      //extent: [-11243808.051695308, 4406397.202710291, -4561377.290892059, 6852382.107835932]
    }),
  ],
  target: "map",
  //layers
  layers: [
    baseLayers,
    marcoGeoestadistico,
    censo2022,
    censo2010,
    censo2001,
    cartografiaBase,
    fuentesExternas,
  ],
  //vista
  view: new View({
    center: [-7269760.5264, -3116502.3825],
    zoom: 8.5,
  }),
});
map.addControl(scaleLine);

//Interacciones con el mapa
//interacción del link guarda el estado actual al actualizar la página
//map.addInteraction(new Link());

//define el switcher y agrega el control al mapa
const layerSwitcher = new LayerSwitcher({
  activationMode: "click",
  tipLabel: "Capas",
  groupSelectStyle: "none",
  reverse: false,
});

map.addControl(layerSwitcher);

//popup y agrega al mapa
const popup = new Popup();
map.addOverlay(popup);

configurarDragAndDrop(map);
configurarInfoFeature(map);
configurarPuntosUsuario(map, () => desactivarControlesActivos(map));

//subir capa
subirCapa(map);

//Evento de cambio de capa
//Evento de cada capa
//
map.getAllLayers().forEach((layer) => {
  layer.on("change:visible", (event) =>
    onLayerVisibilityChange(event, map.getView())
  );
});

//evento del click popup
map.on("singleclick", async (evt) => popUP(evt, map, popup));

// const selectStyle = new Style({
//   stroke: new Stroke({
//     color: "rgba(255, 255, 255, 0.7)",
//     width: 2,
//   }),
// });

// const status = document.getElementById("info");
// let selected = null;
// map.on("pointermove", function (e) {
//   if (selected !== null) {
//     selected.setStyle(undefined);
//     selected = null;
//   }

//   map.forEachFeatureAtPixel(e.pixel, function (f) {
//     console.log(f.getStyle());
//     return true;
//   });

//   if (selected) {
//     status.innerHTML = selected.get("ECO_NAME");
//   } else {
//     status.innerHTML = "&nbsp;";
//   }
// });

//evento de drag de capas activas
cambioOrdenCapasActivas(map);

//impresion de mapas
imprimir(map, scaleLine);

//buscador de localidades IGN
buscadorLocalidades(map);
